import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Document, Page, pdfjs } from 'react-pdf';

interface Props {
  originalFileName: string;
  url: string;
  isOpen: boolean;
  close(): void;
}

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function FileView({ url, isOpen, originalFileName, close }: Props) {
  return (
    <Dialog
      open={isOpen}
      aria-labelledby="Image Preview"
      aria-describedby="alert-dialog-description"
      maxWidth="md">
      <DialogTitle id="alert-dialog-title">{originalFileName}</DialogTitle>
      <DialogContent>
        <Document file={url}>
          <Page
            pageNumber={1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            renderMode="canvas"
          />
        </Document>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FileView;
